export default __webpack_public_path__ + "static/implementation-6f623838f8981a23e98fabd015616ba3.png";